import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  searchSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '5px',
  },
  search: {
    marginBottom: pxToRem(32),
  },
  resultsMessage: {
    marginBottom: pxToRem(8),
    fontWeight: 600,
  },
  noResultsSentence: {
    fontWeight: 400,
  },
  filter: {
    maxWidth: pxToRem(223),
    marginBottom: pxToRem(32),
    width: '100%',
  },
});
